import script from "./BlockTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlockTitle.vue?vue&type=script&setup=true&lang=ts"

import "./BlockTitle.vue?vue&type=style&index=0&id=4eafab8e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eafab8e"]])

export default __exports__